var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4498 12L13.0998 4.64997C12.8498 4.39997 12.7288 4.1083 12.7368 3.77497C12.7448 3.44163 12.8741 3.14997 13.1248 2.89997C13.3755 2.64997 13.6671 2.52497 13.9998 2.52497C14.3325 2.52497 14.6241 2.64997 14.8748 2.89997L22.5748 10.575C22.7748 10.775 22.9248 11 23.0248 11.25C23.1248 11.5 23.1748 11.75 23.1748 12C23.1748 12.25 23.1248 12.5 23.0248 12.75C22.9248 13 22.7748 13.225 22.5748 13.425L14.8748 21.125C14.6248 21.375 14.3288 21.496 13.9868 21.488C13.6448 21.48 13.3491 21.3506 13.0998 21.1C12.8505 20.8493 12.7255 20.5576 12.7248 20.225C12.7241 19.8923 12.8491 19.6006 13.0998 19.35L20.4498 12Z",
    fill: "#042D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMain);
export default __webpack_public_path__ + "static/media/arrow-main.b633dce0a741460ed487e17cf6bf096a.svg";
export { ForwardRef as ReactComponent };